<template>
	<div>
		<v-container class="pa-1 pb-0 text-center">
			<v-card-title class="mb-1 justify-center"><h1>Rates</h1></v-card-title>
			<v-card-text v-if="!hasFixedRates">
				{{ getLabel('ratesSectionHourlyRateText', 'Enter your desired HOURLY Locum rate. Should you need guidance, see our average rates') }}
				<!-- TODO: Get link from tenant configuration, temporarily we get it from label config -->
				<a :href="getLabel('ratesSectionHourlyRateLink', 'https://www.locumbase.com/rate-card')" target="_blank">{{
					getLabel('ratesSectionHourlyRateLinkText', 'here')
				}}</a>
			</v-card-text>
			<v-card-text v-else>
				{{
					getLabel(
						'ratesSectionFixedRateText',
						'Rates for your selected industry are standard across the platform. This ensures fair trading of your time and affordability to the booking practice.'
					)
				}}
			</v-card-text>
		</v-container>

		<v-card-text align="center" justify="center" class="justify-center text-left pb-0 pm-0">
			<locum-rates-form :solo="false"></locum-rates-form>
		</v-card-text>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { bus } from '@/main';
import store from '@/store';
import locumRatesForm from '@/components/locum/profile/RatesForm.vue';

export default {
	components: {
		locumRatesForm,
	},

	data: () => ({
		step: 'rates-step',
	}),

	computed: {
		...mapGetters('tenant', ['tenant']),

		hasFixedRates() {
			if (!this.tenant) return false;
			return this.tenant.settings.workflow.professionalProfile.hasFixedRates;
		},
	},

	mounted() {
		window.scrollTo(0, 0);
	},

	methods: {
		SubmitForm() {
			bus.$emit('intent:submit-forms');
		},
		checkStep(user) {
			const { public_holidays, weekdays, saturday } = user.working_hours;
			if (public_holidays?.rate && weekdays?.rate && saturday?.rate) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else {
				return false;
			}
		},
	},
};
</script>
